import React from 'react';
import { Typography } from 'antd';
const Title = ({ title }: { title: string }) => {
  return (
    <div style={{ display: 'flex' }}>
      <span style={{ display: 'flex', flex: '3 3 0' }}>{title}</span>
      <span style={{ display: 'flex', flex: '1 1 1' }}>
        <Typography.Link style={{ fontSize: 12 }}>
          View Order Details
        </Typography.Link>
      </span>
    </div>
  );
};

export default Title;
